// src/hooks/useScrollPreservation.js
import { useRef, useCallback } from 'react';

export const useScrollPreservation = () => {
  const scrollRef = useRef(null);
  const scrollPositionRef = useRef(0);

  const saveScrollPosition = useCallback(() => {
    if (scrollRef.current) {
      scrollPositionRef.current = scrollRef.current.scrollTop;
    }
  }, []);

  const restoreScrollPosition = useCallback(() => {
    if (scrollRef.current) {
      requestAnimationFrame(() => {
        scrollRef.current.scrollTop = scrollPositionRef.current;
      });
    }
  }, []);

  const preventScrollJump = useCallback((callback) => {
    saveScrollPosition();
    if (callback) callback();
    requestAnimationFrame(() => {
      restoreScrollPosition();
    });
  }, [saveScrollPosition, restoreScrollPosition]);

  return {
    scrollRef,
    saveScrollPosition,
    restoreScrollPosition,
    preventScrollJump
  };
};

export default useScrollPreservation;